export default function HrAttendance() {
    return (
      <div className="p-6 bg-white rounded-xl shadow space-y-6">
        <h1 className="text-3xl font-bold text-gray-700">Attendance</h1>
        <p className="text-gray-500">View and manage attendance records of employees.</p>
        <div className="overflow-x-auto">
          <table className="min-w-full table-auto border border-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 border">Employee Name</th>
                <th className="p-3 border">Date</th>
                <th className="p-3 border">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-3 border">John Doe</td>
                <td className="p-3 border">2025-12-06</td>
                <td className="p-3 border text-green-500 font-semibold">Present</td>
              </tr>
              <tr>
                <td className="p-3 border">Jane Smith</td>
                <td className="p-3 border">2025-12-06</td>
                <td className="p-3 border text-red-500 font-semibold">Absent</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
  